import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '../../../components/modal';
import Preloader from '../../../components/preloader';
import EmptyState from '../../../components/empty-state-container';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';

import {connect} from 'react-redux';

let dbList;

class ManageDatabase extends Component {

  constructor(props) {
    super(props);
    this.state = {
      menuAnchorEl: null,
      menuOpenId: null,
      dbFilterCriteria:"",
      emptyState:"You do not have any DB Connections.",
      deleteDbVal:"",
      modalOpen:false,
      modalTitle:"",
      modalContent:"",
      modalPrimaryButton:"",
      modalSecondaryButton:""
    };
  }


componentDidMount=()=>{
  this.setState({
    dbFilterCriteria:""
  });
}




editDB = (db) => {
    //this.props.getRuleSetContent("edit-account");
    this.props.onClick({db});
}

modalClose=()=>{
  this.setState({
    modalOpen:false
  });
}

modalConfirm=()=>{

  this.setState({
    modalOpen:false
  });
  let deleteObj={
      dbConnectionId:this.state.deleteDbVal.connId,
      dbConnectionName: this.state.deleteDbVal.name
  }
  this.props.deleteDB(deleteObj);
}

deleteItem = (db) => {
    //this.props.getRuleSetContent(value);
    //this.props.onClick(value);
    this.setState({
      modalOpen:true,
      modalTitle:"Delete Connection",
      modalContent:"Are you sure you want to delete \""+db.name+"\"?",
      modalPrimaryButton:"Yes",
      modalSecondaryButton:"No",
      modalState:"delete",
      deleteDbVal:db
    });
}

  createNewConnection = () => {
    this.props.onClick('new');
}





   render() {






     const {isLoading} = this.props;
     let manageDbContent,dbListContent;

     if(isLoading.includes('dblist')){
       manageDbContent=<Preloader loading={true} /> ;
     }
     else if(this.props.dbList !== undefined){

      const filterCriteria=this.state.dbFilterCriteria;
      dbList = this.props.dbList.filter(function (e) {  return e.name.toLowerCase().includes(filterCriteria.toLowerCase()); } );


      if(dbList.length>0){
        dbListContent=<table className='manage-ruleset-table'>
        <tbody>
             {dbList.map((db,index) => <tr key={index}>
               <td onClick={this.editDB.bind(this,db)} className='user' >{db.name}</td>
               <td>
               <div className='actions-menu'>
                 <IconButton onClick={(e) => this.setState({ menuAnchorEl: e.currentTarget, menuOpenId: index })}>
                   <i className='material-icons'>more_horiz</i>
                 </IconButton>
                 <Menu 
                   anchorEl={this.state.menuAnchorEl} 
                   open={Boolean(this.state.menuAnchorEl) && this.state.menuOpenId === index} 
                   onClose={() => this.setState({ menuAnchorEl: null, menuOpenId: null })}
                   anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                   transformOrigin={{horizontal: 'right', vertical: 'top'}}
                 >
                   <MenuItem className='wl-group-card-menu'
                   onClick={this.deleteItem.bind(this,db)}>Delete</MenuItem>
               </Menu>
               </div>
                </td>
               </tr>)}
       </tbody>
        </table>
      }else{
        dbListContent=<EmptyState className="margin-top-0" message={this.state.emptyState} />
      }
       manageDbContent=<Row>

       <Col sm={4} xs={6}>{dbListContent}</Col>
       <Col sm={4} xs={6} className="manage-rule-buttons">

          <Button href=""  onClick={this.createNewConnection.bind(this)} className='createruleset-button'>Add a new connection</Button>
       </Col>

       </Row>
     }

     return (
       <div>
       <Modal
        open={this.state.modalOpen}
        title={this.state.modalTitle}
        content={this.state.modalContent}
        primaryButton={this.state.modalPrimaryButton}
        secondaryButton={this.state.modalSecondaryButton}
        close={this.modalClose}
        confirm={this.modalConfirm}
        />
       <div className="manage-ruleset margin-top-30">

       {manageDbContent}

       </div>

         </div>

     );
   }
}


const mapStateToProps = (state) => {
  return{
    isLoading: state.databaseReducer.isLoading,
    errors: state.databaseReducer.errorMessage
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {

  }
}


export default connect(mapStateToProps,mapDispatchToProps) (ManageDatabase);
